export default __webpack_public_path__ + "static/media/retail2.faa61669.svg";